module.exports = __webpack_public_path__ + "static/media/ati.f8bdd4c2.svg";